import { Typography } from '@mui/material';
import useTemplateSx from '../../hooks/useTemplateSx';

export default function RequiredLabel({ children }) {
  const styles = useTemplateSx();

  return (
    <Typography component="span">
      {children}{' '}
      <Typography component="span" sx={{ color: styles.accent?.primary ?? 'error.main' }}>
        *
      </Typography>
    </Typography>
  );
}
